import { z } from "zod";

import { DatabaseIdentity } from "@/core/api";
import { AttachmentLike } from "@/data/attachments";
import { LegalEntity } from "@/data/types/LegalEntity";

export const PublicProfile = z
  .object({
    name: z.string(),
    slug: z.string(),
    facebookSlug: z.string().nullable(),
    twitterSlug: z.string().nullable(),
    instagramSlug: z.string().nullable(),
    linkedinSlug: z.string().nullable(),
    aboutUs: z.string(),
    backgroundImage: AttachmentLike.nullable(),
    logo: AttachmentLike,
    companySize: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    website: z.string().nullable(),
    newsCount: z.number(),
    benefits: z.array(z.string()),
    legalEntities: z.array(LegalEntity).nullable(),
  })
  .merge(DatabaseIdentity)
  .passthrough();

export type PublicProfile = z.infer<typeof PublicProfile>;
